// Browsers may send a textarea line break as \n or \r\n, and the backend counts every character of it; sending \r\n
// always keeps the length the panel checks equal to the one the backend checks.
export const toCrLf = (value: string) => value.replace(/\r?\n/g, "\r\n");
